import { PRECISION } from '../constants';

import { round } from '../../util';

export default function close(a, b, tolerance) {
    if ( tolerance === void 0 ) tolerance = PRECISION;

    return round(Math.abs(a - b), tolerance) === 0;
}


//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-drawing/dist/es/geometry/math/close.js
// module id = ../../../../@progress/kendo-drawing/dist/es/geometry/math/close.js
// module chunks = vendor